<template>
    <ul>
        <li v-for="m in menuItems"
            :key="m.label"
            :style="m.style"
            v-ripple-tap
            @click="menuClick(m)"
            :class="{active: m.to === $router.currentRoute.path}">
            <span>
                <svg-icon :icon="m.icon" :svg-class="m.svgClass"/>
                <transition name="badge-menu">
                    <span v-if="crudNotifications[m.group] && crudNotifications[m.group].content"
                          class="badge"
                          :class="crudNotifications[m.group].color"
                          :key="m.group">{{crudNotifications[m.group].content}}</span>
                </transition>
                <span class="label">{{m.label}}</span>
            </span>
        </li>
    </ul>
</template>

<script>
    import {createNamespacedHelpers, mapGetters, mapActions} from 'vuex'
    const usersStore = createNamespacedHelpers('users');

    const menuProfile = {
        to: '/users/profile',
        active: false,
        icon: 'id-card',
        label: 'Perfil'
    };

    const menuCustomer = {
        to: '/customers',
        active: false,
        icon: 'users',
        label: 'Clientes',
        group: 'customers'
    };

    const menuInvoice = {
        to: '/invoices',
        active: false,
        icon: 'file-invoice-dollar',
        label: 'Notas'
    };

    const menu = {
        to: '/menu',
        active: false,
        icon: 'bars',
        label: 'Menu'
    };

    export default {
        name: "BottomMenuMob",
        props: {
            items: {
                type: Array,
                default: () => [{
                    to: '/dashboard',
                    active: false,
                    icon: 'tachometer-alt',
                    label: 'Dashboard'
                },{
                    to: '/proposals',
                    active: false,
                    icon: 'handshake',
                    label: 'Contratos',
                    group: 'proposals'
                }, menuCustomer, menuInvoice,menu]
            }
        },
        methods: {
            ...mapActions(['changeCrudNotifications']),
            menuClick(m) {
                if (m.group) {
                    const item = this.crudNotifications[m.group];
                    if (item) {
                        const notification = {...this.crudNotifications};
                        delete notification[m.group];
                        this.changeCrudNotifications(notification);
                    }
                }

                if (m.to) {
                    setTimeout(() => {
                        this.$router.push(m.to);
                        this.$emit('onMenuClickItem', m);
                        }, 150);
                } else {
                    this.$emit('onMenuClickItem', m);
                }
            }
        },
        computed: {
            ...mapGetters(['crudNotifications']),
            ...usersStore.mapGetters(['userSession']),
            menuItems() {
                const user = this.userSession;
                let items = [...this.items];

                if (user) {
                    if (user.profile === 'broker') {
                        items.splice(3, 1, menuProfile);
                    } else if (user.profile === 'backoffice') {
                        items = [{
                            to: '/financial_movements',
                            active: false,
                            icon: 'cash-register',
                            label: 'Financeiro',
                            group: 'financial_movements'
                        }, menuInvoice, menuCustomer, menuProfile, menu]
                    }
                }

                return items;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/variables";

    ul {
        margin: 0;
        padding: 0;
        list-style: none;
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        height: 100%;


        li {
            height: 100%;
            padding-top: 10px;

            &.active {
                background-color: $theme_color_one
            }

            a, span {
                color: $theme_color_four;
                display: block;
                text-align: center;
                text-decoration: none;
                position: relative;

                svg {
                    width: 25px;
                    height: 25px;
                    display: inline-block;
                }

                span {
                    &.label {
                        margin-top: 5px;
                        display: block;
                        font-size: .7em;
                    }

                    &.badge {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: absolute;
                        left: 50px;
                        top: 0;
                        font-size: .8em;
                        border-radius: 10px;
                        height: 20px;
                        min-width: 20px;
                        padding: 0 3px;
                        font-weight: 700;
                        box-shadow: 1px 1px 2px 0 rgba(0,0,0,.5);

                        &.red {
                            background-color: #f00;
                        }
                    }
                }
            }
        }
    }
</style>
